import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';

import { renderField } from '../utilities/form';
import { required } from '../utilities/validation';

const CategoryForm = ({ title, handleSubmit, invalid, submitting, ...props }) => {
  return (
    <React.Fragment>
      <div className="flex flex-wrap justify-center">
        <div className="w-full max-w-lg relative">
          <h1 className="font-black font-serif mb-8 text-3xl tracking-tight block text-black">{ title }</h1>
        </div>
        <form className="w-full max-w-lg" onSubmit={handleSubmit}>
          <div className="flex flex-wrap -mx-3 md:mb-2">
            <div className="w-full md:w-full px-3 mb-6 md:mb-2">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                Nome
              </label>
              <Field
                id="title"
                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                name="name"
                type="text"
                component={renderField}
                placeholder="e.g. German"
                disabled={props.loading}
                validate={[required]} />
            </div>
          </div>
          <div className="flex flex-wrap -mx-3 md:mb-2">
            <div className="w-full px-3 mb-6 md:mb-2">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="description">
                Descrizione
              </label>
              <Field
                id="description"
                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                name="description"
                type="textarea"
                rows={5}
                component={renderField}
                placeholder="e.g. Un gioco straordinario di deduzione..."
                disabled={props.loading} />
            </div>
          </div>
          <div className="flex flex-wrap justify-center">
            <button disabled={invalid || submitting} className={`w-full md:w-auto bg-blue-700 text-white font-bold py-4 px-4 rounded ${invalid || submitting ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:bg-blue-800'}`} type="submit">
              Salva
            </button>
          </div>
        </form>
      </div>
    </React.Fragment>
  );
};

CategoryForm.propTypes = {
  title: PropTypes.string,
};

export default reduxForm({
  form: 'category',
})(CategoryForm);
